import { render } from "./CanvasVista.vue?vue&type=template&id=c125d394&scoped=true"
import script from "./CanvasVista.vue?vue&type=script&lang=js"
export * from "./CanvasVista.vue?vue&type=script&lang=js"

import "./CanvasVista.vue?vue&type=style&index=0&id=c125d394&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c125d394"]])

export default __exports__